import { useQuery } from "@tanstack/react-query";
import { getAllCallCenterStatus, getAllCallCenterQuery, getCallCenterReports, downloadCallCenterReport } from "../../service/query/auth";



export const useGetCallCenterQuery = () => {
  const getCallCenterQuery = useQuery({
    queryKey: ["call_center_query"],
    queryFn: getAllCallCenterQuery,
    enabled: true,
    keepPreviousData: true,
  });
  return { data: getCallCenterQuery?.data?.data, ...getCallCenterQuery };
};

export const useGetCallCenterStatus =()=> {
  const getCallCenterStatus = useQuery({
    queryKey: ["call_center_status"],
    queryFn: getAllCallCenterStatus,
    enabled: true,
    keepPreviousData: true,
  });
  return { data: getCallCenterStatus?.data?.data, ...getCallCenterStatus };
};

// GET ALL CALL CENTER REPORT 
export const useGetCallCenterReport = ({ payload, page }) => {
  const getAllCallCenterReport= useQuery({
    queryKey: ['call_center_report', payload, page],
    queryFn: () => getCallCenterReports({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);


  return {data:getAllCallCenterReport?.data?.data,  ...getAllCallCenterReport,}
};

//DOWNLOAD CALL CENTER REPORT 
export const useDownloadCallCenterReport=({ payload, page }) => {
  const downloadReport= useQuery({
    queryKey: ['call_center_report', payload, page],
    queryFn: () => downloadCallCenterReport({ ...payload}),
    enabled: !!payload,
    keepPreviousData: true,
  },
);
 return {data:downloadReport?.data?.data,  ...downloadReport,}
};